import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { RecommendationTarget, Recommendee } from '../types';
import { getMissingDocuments, renderRecommendeeFullName } from '../utils';
import { recommendationFileTypes } from '../recommendationFileTypes';
import { useLang } from '../LanguageContextProvider';
import { renderDeadline } from '../recommendationDeadline';

interface RecommendationHomeProps {
    name: string | null;
    email: string;
    data: Recommendee[];
    setSelectedTarget: React.Dispatch<React.SetStateAction<RecommendationTarget | null>>;
}

const RecommendationHome: React.FC<RecommendationHomeProps> = ({ name, email, data, setSelectedTarget }) => {
    const missingDocuments = getMissingDocuments(data);
    const { lang } = useLang();

    return (
        <Stack alignItems="center" spacing={6} padding="16px">
            <Stack height="96px" />
            <Stack spacing={1}>
                <Typography variant="h6">{lang === 'en' ? 'Hello ' : ''}<span style={{ fontWeight: 'bold' }}>{name ?? email}</span>{lang === 'en' ? ',' : ' 様'}</Typography>
                {data.length > 0 ? (
                    missingDocuments.length > 0 ? (
                        <Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                {lang === 'en' ? <Typography variant="h5">There are</Typography> : null}
                                <Typography variant="h4">{missingDocuments.length}</Typography>
                                <Typography variant="h5">{lang === 'en' ? 'more files that you need to upload' : '点の文書がアップロード未完了です。'}</Typography>
                            </Stack>
                            <Typography variant="h5">{lang === 'en' ? 'by ' : '期限は '}<span style={{ fontWeight: 'bold' }}>{renderDeadline(lang)}</span>{lang === 'en' ? '.' : ' です。'}</Typography>
                        </Stack>
                    ) : <Typography variant="h6">{lang === 'en' ? `You have uploaded all the documents required. Thank you for taking the time to upload the document(s). Please double check the uploaded documents from the left menu and re-upload as needed before the deadline (${renderDeadline(lang)}). If you have any questions, please reach out to it@grew-bancroft.or.jp.` : `全ての文書がアップロード済です。お疲れ様でした。念の為、左のメニューからアップロードした文書の内容を確認してください。締切前なら何度でも再アップロードが可能です (${renderDeadline(lang)})。ご質問があれば it@grew-bancroft.or.jp までお問合せください。`}</Typography>
                ) : (
                    <Stack>
                        <Typography variant="h6">{lang === 'en' ? 'No applicant has assigned you as a recommender yet.' : '調査書もしくは推薦状アップロードの依頼がまだ届いていません。'}</Typography>
                    </Stack>
                )}
            </Stack>
            <Stack spacing={2}>
                {missingDocuments.map(({ recommendee, fileType }) => (
                    <Stack key={`Recommendationhome-${recommendee.applicantNum}-${fileType}`} direction="row" alignItems="center" spacing={3} width="600px">
                        <Stack direction="row" alignItems="center" flex={5} spacing={2}>
                            <Avatar alt={renderRecommendeeFullName(recommendee, lang)} src={recommendee.imageUrl} />
                            <Typography variant="h5" sx={{ flex: 1 }}>{renderRecommendeeFullName(recommendee, lang)}</Typography>
                        </Stack>
                        <Typography variant="h6" sx={{ flex: 2 }}>{recommendationFileTypes[fileType][lang]}</Typography>
                        <IconButton color="primary" onClick={() => setSelectedTarget({ recommendee, fileType })}>
                            <FileUploadIcon />
                        </IconButton>
                    </Stack>
                ))}
            </Stack>
        </Stack>

    );
};

export default RecommendationHome;